import { ProblemDetail } from '../error';

export interface SnackbarConfig {
  show: boolean;
  type?: SnackbarType;
  message?: string;
  problemDetail?: ProblemDetail;
}

export enum SnackbarType {
  Simple,
  Super,
  ProblemDetail
}
